import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import i18next from "i18next";
import { DeleteSystemTerm } from "services/systemTerms";

export default function useDeleteSystemTerm() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(DeleteSystemTerm, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            type: "success",
            message:
              i18next.language === "ar"
                ? "تم الحذف بنجاح"
                : "Deleted successfullys",
          });
          queryClient.invalidateQueries("system-terms");
        }
      },
    }),
  };
}
